import { cn } from '#app/utils/misc.tsx'

export function HairlineRule({ className }: { className?: string }) {
	return (
		<span aria-hidden className={cn('block h-px w-12 bg-ember', className)} />
	)
}
